import React from 'react';

import { SlidersHorizontal } from 'lucide-react'
import { DropdownMenuItem } from 'twyne-new.ui'

import { ConfigureButton, HeaderSeparator, ReportDatePicker, ReportHeader, ReportHeaderDates, ReportHeaderDesktopActions, ReportHeaderMobileActions, ReportMobileMenu, RunButton } from '@/components/reports/header'

export default function OptoutSummaryHeader({ onClickFilter, onChangeDates, dates, sync, isLoading }) {
  return <>
    <ReportHeader title='Optout Summary Report'>
      <ReportHeaderDates>
        <ReportDatePicker dates={dates} onChange={onChangeDates} />
      </ReportHeaderDates>
      <HeaderSeparator />
      <ReportHeaderDesktopActions>
        <ConfigureButton onClick={onClickFilter} />
      </ReportHeaderDesktopActions>
      <ReportHeaderMobileActions>
        <ReportMobileMenu>
          <DropdownMenuItem icon={SlidersHorizontal} onSelect={onClickFilter}>Configure</DropdownMenuItem>
        </ReportMobileMenu>
        <RunButton isLoading={isLoading} disabled={isLoading} onClick={sync} />
      </ReportHeaderMobileActions>
    </ReportHeader>
  </>
}
